import partner_hero from '../../images/partner_hero.png';
import { useState } from 'react';
import GetInTouch from './GetInTouch';
const PartnerHero = () => {
    const [imageLoaded, setImageLoaded] = useState(false)
    return (
        <div className="partner-hero-background">
            <div className="containerAF max-width partner-hero-container">
                <div className="partner-hero-text">
                    <h1 className="main-title">Earn More, Earn Respect, Safety Ensured.</h1>
                    <p className="description">Join 5,500+ partners across Mumbai, Pune.</p>
                </div>
                <div className="partner-hero-image">
                    <div className="ui placeholder" style={{display: imageLoaded ? "none" :  'block'}}>
                        <div className="image"></div>
                    </div>
                    <img src={partner_hero} alt="partner-hero" className="partner-image" style={{display: imageLoaded ? "block" : "none"}} onLoad={() => setImageLoaded(true)}/>
                </div>
            </div>
            <GetInTouch />
        </div>
    )
}
export default PartnerHero